// extracted by mini-css-extract-plugin
export default {"header":"JI2T5kIMQNE5DayFptCy"};